/** Status das amostras dos pedidos */
export interface PedidoStatusAmostra {
    id: number;
    nome: string;
    badge: string;
}

export const pedidoStatusAmostraPendente: PedidoStatusAmostra = {
    id: 1,
    nome: 'Pendente',
    badge: 'badge-pedido-tipo-amostra-pendente'
};
export const pedidoStatusAmostraFinalizada: PedidoStatusAmostra = {
    id: 2,
    nome: 'Finalizada',
    badge: 'badge-pedido-tipo-amostra'
};

export const pedidoStatusAmostra: PedidoStatusAmostra[] = [
    pedidoStatusAmostraPendente,
    pedidoStatusAmostraFinalizada
];

/** Verifica se o status da amostra é igual a Pendente */
export function isPedidoStatusAmostraPendente(id: number): boolean {
    return id === pedidoStatusAmostraPendente.id;
}

/** Verifica se o status da amostra é igual a Finalizada */
export function isPedidoStatusAmostraFinalizada(id: number): boolean {
    return id === pedidoStatusAmostraFinalizada.id;
}
